"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.getStatusTheme = void 0;
const react_1 = __importStar(require("react"));
const UiKitContext_1 = require("./UiKitContext");
const UiKitIcons_1 = require("./UiKitIcons");
const consistency_1 = require("./consistency");
const getStatusTheme = (status) => {
    let icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.Info, null);
    let highlightColor;
    let backgroundColor;
    let label;
    let textColor;
    const useNewBranding = (0, react_1.useContext)(UiKitContext_1.UiKitContext).useNewBranding;
    if (status === 'tip') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Global.TipOutline, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.cautionAlert.background : consistency_1.consistency.warning50;
        backgroundColor = useNewBranding
            ? consistency_1.consistency.brandColors.cautionAlert.background
            : consistency_1.consistency.warning05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.cautionAlert.font : consistency_1.consistency.black;
        label = 'Tip';
    }
    else if (status === 'remove') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.Cancel, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.negativeAlert.background : consistency_1.consistency.error50;
        backgroundColor = useNewBranding ? consistency_1.consistency.brandColors.negativeAlert.background : consistency_1.consistency.error05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.negativeAlert.font : consistency_1.consistency.black;
        label = 'Remove';
    }
    else if (status === 'warning') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.Warning, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.cautionAlert.background : consistency_1.consistency.warning50;
        backgroundColor = useNewBranding
            ? consistency_1.consistency.brandColors.cautionAlert.background
            : consistency_1.consistency.warning05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.cautionAlert.font : consistency_1.consistency.black;
        label = 'Warning';
    }
    else if (status === 'warning outline') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.WarningOutline, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.cautionAlert.background : consistency_1.consistency.warning50;
        backgroundColor = useNewBranding
            ? consistency_1.consistency.brandColors.cautionAlert.background
            : consistency_1.consistency.warning05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.cautionAlert.font : consistency_1.consistency.black;
        label = 'Warning';
    }
    else if (status === 'todo') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.ToDo, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.neutralAlert.background : consistency_1.consistency.gray50;
        backgroundColor = useNewBranding ? consistency_1.consistency.brandColors.neutralAlert.background : consistency_1.consistency.gray05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.neutralAlert.font : consistency_1.consistency.black;
        label = 'To Do';
    }
    else if (status === 'in progress') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.InProgress, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.neutralAlert.background : consistency_1.consistency.gray50;
        backgroundColor = useNewBranding ? consistency_1.consistency.brandColors.neutralAlert.background : consistency_1.consistency.gray05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.neutralAlert.font : consistency_1.consistency.black;
        label = 'In Progress';
    }
    else if (status === 'success') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.Success, null);
        highlightColor = useNewBranding
            ? consistency_1.consistency.brandColors.positiveAlert.background
            : consistency_1.consistency.success50;
        backgroundColor = useNewBranding
            ? consistency_1.consistency.brandColors.positiveAlert.background
            : consistency_1.consistency.success05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.positiveAlert.font : consistency_1.consistency.black;
        label = 'Success';
    }
    else if (status === 'success outline') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.SuccessOutline, null);
        highlightColor = useNewBranding
            ? consistency_1.consistency.brandColors.positiveAlert.background
            : consistency_1.consistency.success50;
        backgroundColor = useNewBranding
            ? consistency_1.consistency.brandColors.positiveAlert.background
            : consistency_1.consistency.success05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.positiveAlert.font : consistency_1.consistency.black;
        label = 'Success';
    }
    else if (status === 'error') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.Error, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.negativeAlert.background : consistency_1.consistency.error50;
        backgroundColor = useNewBranding ? consistency_1.consistency.brandColors.negativeAlert.background : consistency_1.consistency.error05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.negativeAlert.font : consistency_1.consistency.black;
        label = 'Error';
    }
    else if (status === 'error outline') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.ErrorOutline, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.negativeAlert.background : consistency_1.consistency.error50;
        backgroundColor = useNewBranding ? consistency_1.consistency.brandColors.negativeAlert.background : consistency_1.consistency.error05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.negativeAlert.font : consistency_1.consistency.black;
        label = 'Error';
    }
    else if (status === 'info') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.Info, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.infoAlert.background : consistency_1.consistency.info50;
        backgroundColor = useNewBranding ? consistency_1.consistency.brandColors.infoAlert.background : consistency_1.consistency.info05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.infoAlert.font : consistency_1.consistency.black;
        label = 'Info';
    }
    else if (status === 'info outline') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.InfoOutline, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.infoAlert.background : consistency_1.consistency.info50;
        backgroundColor = useNewBranding ? consistency_1.consistency.brandColors.infoAlert.background : consistency_1.consistency.info05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.infoAlert.font : consistency_1.consistency.black;
        label = 'Info';
    }
    else if (status === 'question') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Global.Help, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.infoAlert.background : consistency_1.consistency.info50;
        backgroundColor = useNewBranding ? consistency_1.consistency.brandColors.infoAlert.background : consistency_1.consistency.info05;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.infoAlert.font : consistency_1.consistency.black;
        label = 'Question';
    }
    else if (status === 'deleted') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.XInsideCircle, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.neutralAlert.background : consistency_1.consistency.gray10;
        backgroundColor = useNewBranding ? consistency_1.consistency.brandColors.neutralAlert.background : consistency_1.consistency.gray10;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.neutralAlert.font : consistency_1.consistency.black;
        label = 'Deleted';
    }
    else if (status === 'processing') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.HalfHalfCircle, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.infoAlert.background : consistency_1.consistency.info50;
        backgroundColor = useNewBranding ? consistency_1.consistency.brandColors.infoAlert.background : consistency_1.consistency.info20;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.infoAlert.font : consistency_1.consistency.black;
        label = 'Processing';
    }
    else if (status === 'neutral') {
        icon = react_1.default.createElement(UiKitIcons_1.UiKitIcons.Status.Info, null);
        highlightColor = useNewBranding ? consistency_1.consistency.brandColors.neutralAlert.background : consistency_1.consistency.gray10;
        backgroundColor = useNewBranding ? consistency_1.consistency.brandColors.neutralAlert.background : consistency_1.consistency.gray10;
        textColor = useNewBranding ? consistency_1.consistency.brandColors.neutralAlert.font : consistency_1.consistency.black;
        label = 'Info';
    }
    else {
        throw new Error(`unexpected status: ${status}`);
    }
    return {
        icon,
        highlightColor,
        backgroundColor,
        textColor,
        label,
    };
};
exports.getStatusTheme = getStatusTheme;
